module.exports = __webpack_public_path__ + "static/Masaba-Coffee-8420910035375b6ae8806f94eaed12e3.png";